(function() { module.exports = window["Next"]["Menu"]; }());